import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteDocument($companyId: ID!, $id: ID!) {
    deleteDocument(companyId: $companyId, id: $id) {
      document {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
